import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Badge = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: ${({ theme }) => theme.palette.text.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 0;
  right: 0;

  padding: ${({ theme }) => `0 ${theme.spacing(0.75)}`};
  height: 1.6rem;
  min-width: 1.6rem;

  border-radius: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  background: ${({ theme }) => theme.palette.backgroundExtended.card};
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.4);
`;
